<template>
  <b-container class="wrap-contact">
    <div class="box-head">
      <h1>ADMIN CONTACT</h1>
    </div>

    <b-row>
      <b-col
        v-for="(contact, i) in contacts"
        :key="i"
        cols="12"
        md="6"
        class="box-content"
      >
        <div class="box"></div>
          <div class="box-text">
            <h2>{{ contact.title }}</h2>
            <p>{{ contact.dec }}</p>
        </div>
      </b-col>
    </b-row>
    <img src="@/assets/images/map_contact.png">
  </b-container>
</template>

<script>
export default {
  data () {
    return {
      contacts: [
        {
          title: 'บริษัท แพลนโนวา จำกัด C/O ADMAN AWARDS & SYMPOSIUM',
          dec: 'ที่อยู่ : 1537 ทาวน์ อิน ทาวน์ ซอย 3/1 ถนนศรีวรา แขวงพลับพลา เขตวังทองหลาง กรุงเทพฯ 10310 โทร 0-2530-9300 แฟกซ์ 0-2530-9291-3 เว็บไซต์ www.plannova.co.th'
        },
        {
          title: 'ติดต่อสอบถาม',
          dec: 'คุณกิติศักดิ์ ปิยะวงค์ (เบนซ์) ต่อ 15 Email: kitisak@plannova.co.th\nคุณเกศวดี แก่งศิริ (บอม) ต่อ 27 Email: katwadee@plannova.co.th'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-contact {
  .box-head {
    padding: 22px 0;

    h1 {
      font-size: 1.5rem;
    }
  }

  .row {
    .box-content {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 22px;

      .box {
        margin-top: 5px;
        width: 15px;
        height: 15px;
        background-color: $active;
      }

      .box-text {
        margin-left: 12px;
        width: 100%;

        h2 {
          font-size: 1.5rem
        }

        p {
          margin-top: 8px;
          line-height: 1;
          font-size: 1.25rem
        }
      }
    }
  }

  img {
    width: 100%;
    margin-bottom: 22px;
  }
}
</style>
